/**
 * SP_塾診断用サジェスト機能 （サジェスト表示を画面要素に被せる形ではなく指定箇所に挿入するサジェスト）
 */
let suggestProcess;

/**
 * 診断モーダル用サジェストイベントを登録する
 */
function registMatchSuggestAction() {
	// サジェストプラグイン本体
	$.fn.suggestSp = function(url) {
		// オプションの読み込み
		options = {};
		options.url = url; // ajax通信するURL
		options.minChars = 1; // サジェスト表示開始文字数
		options.data = new Object;// ajax通信で渡すパラメータ
		options.suggestClass = "js-line-search-prediction"; // サジェスト表示の親クラス
		
		var timerId = '';
		
		// フォーカスがあたった場合は画面をモーダル表示に変更しサジェスト開始
		this.on("focus", function() {
			// 関数内でthisを使用するために変数に格納
			contents = $(this);
			textValue = contents.val();
			
			// フォーカスがあたったときに既に文字が入力されていれば1度サジェストリストを出す。
			if (textValue.length >= options.minChars) suggest();
			
			// timerIdが空でなければクリアする
			if (timerId != '') {
				clearInterval(timerId);
				timerId = '';
			}
			
			// 入力された値を定期監視 500ミリ秒
			timerId = setInterval(function() {
				// 入力された値が変化していればサジェスト開始
				if (textValue != contents.val()) {
					// サジェスト機能呼び出し
					suggest();
					
					// 変化した値を現在の値として格納
					textValue = contents.val();
				}
			}, 500);
			
		});
		
		// フォーカスが外れたら定期監視解除
		this.on("blur", function(){
			clearInterval(timerId);
		});
		
		// サジェスト機能本体
		function suggest() {
			// 入力文字数がサジェスト表示開始文字数を超えてなければ何もせずreturn
			if (options.minChars > contents.val().length) {
				if(contents.val().length == 0) $(".naiv-003").remove();
				return;
			}
			
			// サジェスト検索実行中で終わっていなければ中断して次のajax通信開始
			if (suggestProcess != undefined && suggestProcess != '') suggestProcess.abort();
			
			// 検索キーワード取得
			options.data.suggest_word = contents.val();
			options.data.deduplication = true;
			options.data.limit = 10;
			
			// ajax通信
			suggestProcess = jQuery.ajax({
				type : "POST",
				url : options.url,
				cache : false,
				data : options.data,
			}).done(function(res) {
					// サジェストリストのリセット
					$(".naiv-003").remove();
					
					// サジェスト候補取得後に既に入力が規定文字以下の場合何もしない
					if (options.minChars > contents.val().length) return;
					
					// サジェストリスト表示準備	
					$("." + options.suggestClass).append('<ul class="naiv-003 shindan-chat-answer-box-station-suggest js-suggest-list" id="suggest-list"></ul>');
					
					if (Object.keys(res.list).length > 0) {
						for (var key in res.list) {
							let stationCd = !res.list[key]['Station']['id'] ? "" : res.list[key]['Station']['id'];
							let prefCd = res.list[key]['Prefecture']['pref_cd']
							$('<li class="js-event-tracking js-station-suggest" track_cd="chat_station_search" track_label="' + stationCd + '" data-station-meta-name="' + res.list[key]['Station']['station_meta_name'] + '">' + res.list[key]['Station']['name'] + '</li>').appendTo(".naiv-003").attr('id', stationCd).attr('data-pref_cd', prefCd);
						}
					} else {
						$('<li>該当する駅がありません</li>').appendTo(".naiv-003");
					}

			}).always(function() {
				// イベント設定
				trackEvent.bindEventOnElements('.js-station-check');
			});
		}
	}
	
	// サジェストプラグイン呼び出し
	$('.js-match-suggest-input').suggestSp('/iphone/station/get_autocomplete_json_sp/');
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
    registMatchSuggestAction();
});